import axios from 'axios'

let provinceGeoJsonPromise = null

async function loadProvinceGeoJson() {
  if (!provinceGeoJsonPromise) {
    provinceGeoJsonPromise = axios.get('/china.json')
      .then(response => response.data)
      .catch(async () => {
        const response = await axios.get('/geofusion/china.json')
        return response.data
      })
  }
  return provinceGeoJsonPromise
}

function pointInRing(point, ring) {
  const [x, y] = point
  let inside = false
  for (let i = 0, j = ring.length - 1; i < ring.length; j = i, i += 1) {
    const xi = Number(ring[i]?.[0])
    const yi = Number(ring[i]?.[1])
    const xj = Number(ring[j]?.[0])
    const yj = Number(ring[j]?.[1])
    if (![xi, yi, xj, yj].every(Number.isFinite)) continue
    const intersects = ((yi > y) !== (yj > y)) &&
      (x < ((xj - xi) * (y - yi)) / ((yj - yi) || Number.EPSILON) + xi)
    if (intersects) inside = !inside
  }
  return inside
}

function pointInPolygon(point, polygon) {
  if (!Array.isArray(polygon) || !polygon.length) return false
  if (!pointInRing(point, polygon[0])) return false
  return !polygon.slice(1).some(ring => pointInRing(point, ring))
}

function pointInGeometry(point, geometry) {
  if (!geometry) return false
  if (geometry.type === 'Polygon') {
    return pointInPolygon(point, geometry.coordinates)
  }
  if (geometry.type === 'MultiPolygon') {
    return geometry.coordinates.some(polygon => pointInPolygon(point, polygon))
  }
  return false
}

export async function provinceNameForPoint(longitude, latitude) {
  const lng = Number(longitude)
  const lat = Number(latitude)
  if (!Number.isFinite(lng) || !Number.isFinite(lat)) return ''
  const geoJson = await loadProvinceGeoJson()
  const feature = (geoJson?.features || []).find(item => pointInGeometry([lng, lat], item.geometry))
  return feature?.properties?.name || ''
}

export function provinceNameForPointSync(longitude, latitude, geoJson) {
  const lng = Number(longitude)
  const lat = Number(latitude)
  if (!Number.isFinite(lng) || !Number.isFinite(lat)) return ''
  const feature = (geoJson?.features || []).find(item => pointInGeometry([lng, lat], item.geometry))
  return feature?.properties?.name || ''
}
